import { StringParam } from 'use-query-params';

import { TIMEScreeningState } from '~/store/api/types/timeScreeningStore';

export const careGapQueryParams = {
  pathwayId: StringParam,
  stage: StringParam,
  sites: StringParam,
  patientLinkageId: StringParam,
  location: StringParam,
};

export const paramsToStore = (params: { location?: string | null; patientLinkageId?: string | null }) => {
  return {
    location: params.location,
    patientLinkageId: params.patientLinkageId,
  };
};

export const pickCarePathwayMatchingSidebarFilters = (
  filters: TIMEScreeningState['careGap']['filters'],
): Pick<TIMEScreeningState['careGap']['filters'], 'location' | 'patientLinkageId' | 'sites' | 'stage'> => ({
  stage: filters.stage,
  sites: filters.sites,
  patientLinkageId: filters.patientLinkageId,
  location: filters.location,
});

/** Committed sidebar filters for tab changes (ignores unapplied draft edits in Redux). */
export const mergeCarePathwayMatchingSidebarFilters = (
  applied: TIMEScreeningState['careGap']['filters'],
): Pick<TIMEScreeningState['careGap']['filters'], 'location' | 'patientLinkageId' | 'sites' | 'stage'> =>
  pickCarePathwayMatchingSidebarFilters(applied);

export const storeToParams = (filters: TIMEScreeningState['careGap']['filters']): Record<string, string> => {
  if (!filters.pathway?.value) {
    return {};
  }

  const next: Record<string, string | undefined> = {
    // Key order is intentional for param display in URL
    pathwayId: filters.pathway.value,
    stage: filters.stage?.value,
    sites: filters.sites?.map((s) => s.value).join(',') || undefined,
    patientLinkageId: filters.patientLinkageId || undefined,
    location: filters.location || undefined,
  };

  return Object.fromEntries(Object.entries(next).filter(([, value]) => value !== undefined)) as Record<string, string>;
};
